<div class="container-fluid wrapper" *ngIf="!shouldShowLoader">
    <h3 class="small-heading text-center">Borrower Details</h3>

    <div class="row grey-section my-5" *ngIf="isShowLoanSuggestedTerm()">
        <div class="content-field font-weight-bold d-flex align-items-center">
            <mat-label class="text-color-finzy-blue medium-big-text">Suggested Terms</mat-label>
        </div>

        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">FINL</div>
            <div class="content-value">{{loanSuggestedTerm.generatedLoanId}}</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Name</div>
            <div class="content-value">{{loanSuggestedTerm.name}}</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Loan Amount</div>
            <div class="content-value">{{loanSuggestedTerm.loanAmount | currency:'INR': 'symbol': '2.2'}}</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Indicated Loan Rate</div>
            <div class="content-value">{{loanSuggestedTerm.roi | number : '2.2'}}% p.a.</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Indicated Tenure</div>
            <div class="content-value">{{loanSuggestedTerm.loanTenure}} m</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Suggested Interest Rate</div>
            <div class="content-value">{{loanSuggestedTerm.userSuggestedTerms[0].lenderSuggestedRate | number : '2.2'}}% p.a.</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Suggested Tenure</div>
            <div class="content-value">{{loanSuggestedTerm.userSuggestedTerms[0].lenderSuggestedTenure}} m</div>
        </div>
        <div class="content-field col-lg-3 col-md-4 col-xs-6">
            <div class="content-level">Status</div>
            <div class="content-value">{{loanSuggestedTerm.userSuggestedTerms[0].lenderStatus}}</div>
        </div>
        <div class="content-field col-xs-12 text-right">
            <button type="button" mat-stroked-button class="primary width-12-per" (click)="investmentNegotiationHandler()">
                Modify
            </button>
            <button type="button" class="mat-flat-button primary ml-md-3 mr-md-5 width-12-per" (click)="investmentNegotiationWithdrawnHandler()">
                Withdraw
            </button>
        </div>

    </div>

    <div class="d-flex justify-content-around flex-wrap information-section">
        <div>
            <div>RATING</div>
            <p class="information">{{ data?.rating }}</p>
        </div>
        <div>
            <div>LOCATION</div>
            <p class="information">{{ address?.city }}</p>
        </div>
        <div>
            <div>TENURE</div>
            <p class="information"> {{ loanApplication?.tenure }} months</p>
        </div>
        <div>
            <div>AMOUNT</div>
            <p class="information"> ₹ {{ loanApplication?.amount }}</p>
        </div>
        <div>
            <div>FILLED(%)</div>
            <p class="information">{{ data?.filled_percentage | number : '1.1-2'}} %</p>
        </div>
        <div>
            <div>PURPOSE</div>
            <p class="information">{{ loanApplication?.reason }}</p>
        </div>
    </div>
    <div class="row grey-section" *ngIf="!!data?.profile">
        <div class="col-xs-12 col-sm-6">
            <div class="row finzy-details" *ngIf="!!!data?.sensitiveDetailsHidden">
                <div class="finzy-details-left col-xs-4">
                    Name
                </div>
                <div class="finzy-details-right col-xs-8">
                    {{data?.profile?.name}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Gender
                </div>
                <div class="finzy-details-right col-xs-6">
                    {{data?.profile?.gender}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Age
                </div>
                <div class="finzy-details-right col-xs-6">
                    {{age}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Marital Status
                </div>
                <div class="finzy-details-right col-xs-6">
                    {{data?.profile?.marital_status}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Educational Qualification
                </div>
                <div class="finzy-details-right col-xs-6">
                    {{data?.profile?.educational_qualification}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Salaried/Self Employed
                </div>
                <div class="finzy-details-right col-xs-6">
                    {{livelihoodInformation?.employeeType}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Existing EMI
                </div>
                <div class="finzy-details-right col-xs-6" *ngIf="data?.debt_info?.no_of_loans == 0">
                    No emi
                </div>

                <div class="finzy-details-right col-xs-6" *ngIf="data?.debt_info?.total_emi != 0">
                    ₹ {{data?.debt_info?.total_emi}}
                </div>
            </div>
        </div>

        <div class="col-xs-12 col-sm-6">
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Industry
                </div>
                <div class="finzy-details-right col-xs-6">
                    {{livelihoodInformation?.industry}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-5">
                    Experience
                </div>
                <div class="finzy-details-right col-xs-7">
                    {{experienceInYears}}
                    years {{experienceInMonths}}
                    months
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Number of Loans
                </div>
                <div class="finzy-details-right col-xs-6" *ngIf="data?.debt_info?.no_of_loans != 4">
                    {{data?.debt_info?.no_of_loans}}
                </div>
                <div class="finzy-details-right col-xs-6" *ngIf="data?.debt_info?.no_of_loans == 4 ">
                    More than 3
                </div>
            </div>
            <div class="row finzy-details">
                <div *ngIf="livelihoodInformation?.employeeType == EmployeeType.Salaried"
                     class="finzy-details-left col-xs-6">
                    Monthly income (salaried)
                </div>
                <div class="finzy-details-left col-xs-6"
                     *ngIf="livelihoodInformation?.employeeType == EmployeeType.SelfEmployed">
                    Annual income (self-employed)
                </div>
                <div class="finzy-details-right col-xs-6"
                     *ngIf="livelihoodInformation?.employeeType == EmployeeType.Salaried">
                    ₹ {{livelihoodInformation?.income}}
                </div>
                <div class="finzy-details-right col-xs-6"
                     *ngIf="livelihoodInformation?.employeeType == EmployeeType.SelfEmployed">
                    ₹ {{livelihoodInformation?.income}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-6">
                    Current Loan Amount
                </div>
                <div class="finzy-details-right col-xs-6">
                    ₹ {{data?.loan_amount}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-7">
                    finzy Rating
                </div>
                <div class="finzy-details-right col-xs-5">
                    {{data?.rating}}
                </div>
            </div>
            <div class="row finzy-details">
                <div class="finzy-details-left col-xs-7">
                    finzy Score
                    <br>(out of 900)
                </div>
                <div class="finzy-details-right col-xs-5">
                    {{manualCreditAssessment?.score}}
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-4" *ngIf="!!data?.profile">
        <button type="button" mat-stroked-button class="primary" [mat-dialog-close]="true">Back</button>
        <button *ngIf="isShowSuggestedLoanTermButton()" type="button" class="mat-flat-button primary ml-4" style="width: auto;" (click)="investmentNegotiationHandler()">Negotiate Loan terms</button>
    </div>
</div>
<div *ngIf="shouldShowLoader">
    <mat-spinner [diameter]="35" class="mat-spinner center-block"></mat-spinner>
</div>
